import { ReactNode } from 'react';
import { Box, Column, PageHeader, Row, Screen } from '@tempmee/react';
import styles from './AccountPageLayout.module.scss';

interface IAccountPageLayoutProps {
  /** Page name, on the h4 scale as the page's `<h1>`. */
  title: string;
  /** Renders the header's back arrow and runs on click. */
  onBack?: () => void;
  /** Left column (390px in the design): the topper and the cards under it. */
  aside?: ReactNode;
  /** Right column: the menu cards. */
  children: ReactNode;
}

/**
 * The account area's page chrome (Figma 7169-78327, 7169-77967, 7235-93824,
 * 7293-108401): the header, then white cards on the subdued ground in two
 * columns, 16px in from the edge.
 */
export const AccountPageLayout = ({ title, onBack, aside, children }: IAccountPageLayoutProps) => (
  <Screen variant="standard" className={styles.screen} bodyCardClassName={styles.bodyCard}>
    <PageHeader title={title} variant={onBack ? 'sub' : 'landing'} onBack={onBack} />
    <Box px={4} pb={6}>
      <Row gap={4} align="start">
        {aside && (
          <Column gap={4} className={styles.aside}>
            {aside}
          </Column>
        )}
        <Column gap={4} flex minWidth={0}>
          {children}
        </Column>
      </Row>
    </Box>
  </Screen>
);
